export default __webpack_public_path__ + "bf83fb253cf493d352a2bd7e606567bb.png";